import $, { each } from "jquery";

const ready = function() {
  if ($('.orb').length) {
    // handle color schemes
    let currentColorScheme;
    let colorScheme = localStorage.getItem("color-scheme");

    const colorSchemeSet =['digit', 'autumn', 'card', 'active'];

    if (!localStorage.getItem("color-scheme") || !colorSchemeSet.includes(colorScheme)) {
      colorScheme = $(
        ".color-switch input[type=radio][name=color-switcher]:checked"
      ).val();
    }
    setColorScheme(colorScheme);

    $(".color-switch input[type=radio]").change(function() {
      setColorScheme($(this).val());
    });


    // handle units
    const globalUnitsSet =['em', 'px'];
    
    // let currentGlobalUnits;
    let globalUnits = localStorage.getItem("global-units");
    
    if (!localStorage.getItem("global-units") || !globalUnitsSet.includes(globalUnits)) {
      globalUnits = $(
        ".units-selector input[type=radio][name=units-selector]:checked"
        ).val();
    }

    setGlobalUnits(globalUnits);

    $(".units-selector input[type=radio]").change(function() {
      setGlobalUnits($(this).val());
    });
      
  
    // handle px/em
    // let currentPxInEm
    let pxInEm = localStorage.getItem("px-in-em");
    if (!pxInEm || !Number(pxInEm) || pxInEm > 24 || pxInEm < 14) {
      pxInEm = $(".em-converter input").val();
    } 

    setPxValues(pxInEm);

    $(".em-converter input").change(function() {
      setPxValues($(this).val());
    });

    function getCSSVariable(styles, variable) {
      return styles.getPropertyValue(`--${variable}-RGB`).trim();
    }

    // functions
    function setColorScheme(newColorScheme) {
      $("body").removeClass(currentColorScheme);
      $("body").addClass(newColorScheme);

      localStorage.setItem("color-scheme", newColorScheme);

      $(`.color-switch input[type=radio]`)
        .filter(`[value=${newColorScheme}]`)
        .prop("checked", true);

      $('.graphics').removeClass('visible');
      $(`.graphics.${newColorScheme}`).addClass('visible');
      
      const colorSchemeElement = document.querySelector(`.${newColorScheme}`);
      if (colorSchemeElement) {
        const colorSchemeElementStyles = getComputedStyle(colorSchemeElement);

        $('.orb-palette-sample.text .rgb').text(`rgb(${getCSSVariable(colorSchemeElementStyles, 'text')})`);
        $('.orb-palette-sample.link .rgb').text(`rgb(${getCSSVariable(colorSchemeElementStyles, 'link')})`);
        $('.orb-palette-sample.accent .rgb').text(`rgb(${getCSSVariable(colorSchemeElementStyles, 'accent')})`);
        $('.orb-palette-sample.hover .rgb').text(`rgb(${getCSSVariable(colorSchemeElementStyles, 'hover')})`);
        $('.orb-palette-sample.surface .rgb').text(`rgb(${getCSSVariable(colorSchemeElementStyles, 'surface')})`);
        $('.orb-palette-sample.background .rgb').text(`rgb(${getCSSVariable(colorSchemeElementStyles, 'background')})`);
      }
      
      
      currentColorScheme = newColorScheme;
    }

    function setGlobalUnits(newGlobalUnits) {
      switch (newGlobalUnits) {
        case "em":
          $(".em-converter").removeClass("visible");
          $(".px").hide();
          $(".em").show();
          break;
        case "px":
          $(".em-converter").addClass("visible");
          $(".px").show();
          $(".em").hide();
      }

      localStorage.setItem("global-units", newGlobalUnits);
      $(`.units-selector input[type=radio]`)
        .filter(`[value=${newGlobalUnits}]`)
        .prop("checked", true);
      // currentGlobalUnits = newGlobalUnits;
    }
      
    function setPxValues(newPxInEm) {
      $(".props").each(function() {
        let base = $(this)
        .find(".base")
        .text()
        ? $(this)
          .find(".base")
          .text()
        : "1";
        // console.log(base);

        $(this)
        .find(".value")
        .each(function() {
          let emValue = $(this)
          .find(".em")
          .text();

          if (
          !$(this)
            .find(".em")
            .hasClass("base")
          ) {
          emValue *= base;
          }

          let pxValue = Math.floor(emValue * newPxInEm * 10) / 10;

          $(this)
          .find(".px")
          .text(pxValue);
        });
      });

      localStorage.setItem("px-in-em", newPxInEm);
      $(".em-converter input").val(newPxInEm);
      // currentPxInEm = newPxInEm;

      if($(".orb-options-wrapper").length) {
        $(".depends-em").css("font-size", `${newPxInEm}px`);
      }
    }


    //awakeness
    const awakeness = () => {
      let windowHeight = window.innerHeight;
    
      $(window).resize(function() {
      windowHeight = window.innerHeight;
      });
    
      $(
      ".orb .report-infographics .bar, .orb .poll-infographics .bar, .orb mark"
      ).each(function() {
      var elementMiddle = $(this).offset().top + $(this).height() / 2;
    
      if (
        elementMiddle < $(window).scrollTop() ||
        elementMiddle > $(window).scrollTop() + windowHeight
      ) {
        $(this).addClass("sleep");
      } else {
        $(this).removeClass("sleep");
      }
      });
    };
    awakeness();
    window.addEventListener("scroll", awakeness);

    // download-menu
    $(".download-plate").hover(
      function(e) {
        $(this).addClass("hover");
      },
      function(e) {
        $(this).removeClass("hover");
        $(this)
        .find(".download-menu")
        .removeClass("visible");
    });
    
    $(".download-plate").on("click", function(e) {
      $(this)
        .find(".download-menu")
        .addClass("visible");
    });
  }
};
  
$(document).ready(ready);